import React from 'react'
import SelectedAddress from '../../layout/selected-address.component'
import Button from '../../buttons/buttons.component'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { toastActions, addressesActions } from '../../../actions'
import { StyledAddressSection } from './styles/address-section.style'

const buttonStyle = { marginRight: '15px' }

class BillingAddress extends React.Component {
	componentWillMount() {
		const { clientId, getAddresses, setAddressesOwnerId } = this.props

		setAddressesOwnerId(clientId)
		getAddresses(clientId)
	}

	render() {
		const { addresses, openChangeAddressModal } = this.props

		return (
			<StyledAddressSection>
				{addresses &&
					addresses
						.filter(address => address.billingAddress)
						.map((address, i) => (
							<SelectedAddress key={i} address={address} />
						))}
				<Button
					primary
					type="button"
					style={buttonStyle}
					onClick={() => openChangeAddressModal()}>
					Alterar endereço
				</Button>
			</StyledAddressSection>
		)
	}
}

const mapStateToProps = ({ addresses }) => ({ ...addresses })

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{ danger: toastActions.danger, ...addressesActions },
		dispatch
	)

const connectedBillingAddress = connect(
	mapStateToProps,
	mapDispatchToProps
)(BillingAddress)

export { connectedBillingAddress as BillingAddress }
